<template lang="html">
  <transition name="fade" mode="out-in">
    <router-view />
  </transition>
</template>

<script>
import '@/assets/sass/variables.sass'
export default {
  name: 'Blank'
}
</script>
<style>
  @import '../../../assets/sass/app.scss';
</style>
